import GoogleMapsContainer from "../../../components/miscellaneous/maps/googleMaps";

const GoogleMap = () => {
  return <GoogleMapsContainer />;
};

export default GoogleMap;
